module.exports = __webpack_public_path__ + "img/defaultVoucherIco.c60754be.png";